module.exports = __webpack_public_path__ + "img/ledson.33f5d9f4.png";